import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 20, 50],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'prefix', label: 'Prefix' },
    { key: 'logo', label: 'Logo' },
    { key: 'address', label: 'Address' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/partners', params }
    useIPA.get(param).then(response => {
      const partner = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...partner })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/partner/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      rawData.set('prefix', formData.text_1)
      rawData.set('name', formData.text_2)
      rawData.set('address', formData.text_3)
      if (formData.setImage === 'upload') {
        rawData.append('logo', formData.logo)
      } else {
        rawData.set('logo', formData.logo)
      }
      const param = { rawData, url: 'internal/master/partner', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'partner' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/partner', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, partner) {
    state.items = partner.rows
    state.totalRows = partner.rows.length
    state.options = []
    for (let i = 0; i < partner.rows.length; i++) {
      const option = []
      for (const key in partner.rows[i]) {
        if (key === 'id') {
          option.value = partner.rows[i][key]
        } else if (key === 'name') {
          option.title = partner.rows[i][key]
        } else if (key === 'id') {
          option.oid = partner.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
